/**
 * Created by shaharshelly on 12/6/15.
 */
import IService from '../IService';

export default IService.extend({
  options: {
    /** use builtin result cache for rapid results retrieval */
    enableCache: true,
    MAX_CACHE_SIZE: 64,
  },

  initialize: function () {
    this.$ajax = null;
    this.cache = new Map();
  },

  _getUrl: function (assetModel) {
    return app.apiUrl(
      '/api/v1/assets/{0}/videoAssetStoryBoard'.format(
        encodeURIComponent(assetModel.getMetadata('assetUUID'))
      )
    );
  },

  abort: function () {
    if (app.xhrExpected(this.$ajax)) {
      this.$ajax.abort();
      this.$ajax = null;
    }
  },

  /**
   * Send GET request, expected to be used one at a time singleton)
   * NOTE if in the future there will be need in async independent usages then promise can be used from
   * outside to abort local-scope ajax upon rejection
   * @param assetModel
   * @return {*}
   */
  get: function (assetModel) {
    const promise = $.Deferred();

    if (
      _.isEmpty(assetModel) ||
      !_.isFunction(assetModel.getMetadata) ||
      _.isEmpty(assetModel.getMetadata('assetUUID'))
    ) {
      console.trace('Video asset model is expected, got:', assetModel);
      promise.reject();
    } else {
      const id = assetModel.getMetadata('assetUUID');

      if (
        this.options.enableCache &&
        this.cache.has(id) &&
        assetModel.getMetadata('videoAssetStoryBoard') ===
          this.cache.get(id).length
      ) {
        promise.resolve(this.cache.get(id));
      } else {
        if (app.xhrExpected(this.$ajax)) {
          this.$ajax.abort();
        }

        this.$ajax = $.ajax({
          url: this._getUrl(assetModel),
          type: 'GET',
          error: function () {
            promise.reject();
          },
          timeout: app.TIME.MINUTE,
          success: function (response) {
            if ('OK' === response.response && !_.isEmpty(response.value)) {
              if (this.cache.size >= this.options.MAX_CACHE_SIZE) {
                // maintain cache size limit (FIFO)
                this.cache.delete(this.cache.keys().next().value);
              }
              this.cache.set(id, response.value);
              promise.resolve(response.value);
            } else {
              promise.reject();
            }
          }.bind(this),
        }).always(() => {
          this.$ajax = null;
        });
      }
    }

    return promise;
  },
});
